import { render, staticRenderFns } from "./AnonymousAccount.vue?vue&type=template&id=1dda201c"
import script from "./AnonymousAccount.vue?vue&type=script&lang=js"
export * from "./AnonymousAccount.vue?vue&type=script&lang=js"
import style0 from "./AnonymousAccount.vue?vue&type=style&index=0&id=1dda201c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports